import React, { useState, useEffect } from "react";
import { Button, Pagination } from "rsuite";
import { numberFormatter } from "../../utils";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import MinusRoundIcon from "@rsuite/icons/MinusRound";

const NextTierTable = (props: any) => {

  
  const [selectedVendor, setSelectedVendor] = useState<any>("");
  const [limit, setLimit] = React.useState(10);

  useEffect(()=>{
    if(props.selectedVendor === ""){
      setSelectedVendor("");
      props.updateRebateCategory("");
      props.updateRebateData({});
      props.updateSummaryData({});
    }
  },[props.selectedVendor])

  return (
    <>
      <table className="supplierTable">
        <thead>
          <tr>
            <th>Supplier</th>
            <th>Rebate Category</th>
            <th>Forecasted Spend based on YTD growth</th>
            <th>Forecasted Monthly Spend based on YTD growth</th>
            <th>Forecasted $NIA based on YTD growth</th>
            <th>Additional Monthly Spend required for next tier</th>
            <th>Additional NIA Opportunity</th>
          </tr>
        </thead>
        <tbody>
          {props.data?.map((d: any, index: any) => {
            return (
              <>
                {d.rebateCategories.map((r: any, i: any) => {
                  if (r.category === "Overall") {
                    return (
                      <>
                        <tr
                          key={`${i}_${r.category}`}
                          onClick={() => {
                            setSelectedVendor(d.vendor);
                            props.updateRebateCategory(d.vendor);
                            props.updateRebateData(r.rebatedata);
                            props.updateSummaryData(r.summary);
                            props.updateVendor(d.vendor);
                            props.updateChartData(r.charts);
                          }}
                          className={`${props.selectedRebateCategory !== `${d.vendor}` &&
                              props.selectedVendor !== "" &&
                              selectedVendor !== ""
                              ? "low-opacity clickable"
                              : "clickable"
                            }`}
                        >
                          <td className={`not-clickable ${selectedVendor === d.vendor? 'high-opacity':''}`}>{d.vendor}</td>
                          <td>
                            {d.rebateCategories.length > 1 ?
                              <div className="flex">
                                {selectedVendor === d.vendor ? (
                                  <MinusRoundIcon
                                    className="plusIcon"
                                    onClick={(e: any) => {
                                      setSelectedVendor("");
                                      props.updateRebateCategory("");
                                      props.updateRebateData({});
                                      props.updateSummaryData({});
                                      props.updateVendor("");
                                      e.stopPropagation();
                                    }}
                                  />
                                ) : (
                                  <PlusRoundIcon
                                    className="plusIcon"
                                    onClick={() => {
                                      setSelectedVendor(`${d.vendor}`);
                                      props.updateRebateCategory(d.vendor);
                                      props.updateRebateData(r.rebatedata);
                                      props.updateSummaryData(r.summary);
                                      props.updateChartData(r.charts);
                                      props.updateVendor(d.vendor);
                                    }}
                                  />
                                )}
                                <div>Overall</div>
                              </div>
                              : 'Overall'
                            }
                          </td>
                          <td>
                            {numberFormatter(
                              r.tableData.forecatedSpendBasedonYTDGrowth,
                              0,
                              "$"
                            )}
                          </td>
                          <td>
                            {numberFormatter(
                              r.tableData.forecatedMonthlySpendBasedonYTDGrowth,
                              0,
                              "$"
                            )}
                          </td>
                          <td>
                            {numberFormatter(
                              r.tableData.forecastedNIAbasedonYTDgrowth,
                              0,
                              "$"
                            )}
                          </td>
                          <td>
                            {numberFormatter(
                              r.tableData.additionalMonthlySpendRequired,
                              0,
                              "$"
                            )}
                          </td>
                          <td>
                            {numberFormatter(
                              r.tableData.additinalNIAopp,
                              0,
                              "$"
                            )}
                          </td>
                        </tr>
                      </>
                    );
                  }
                })}

                {selectedVendor === d.vendor
                  ? d.rebateCategories.map((item: any, i: any) => {
                    if (item.category !== "Overall") {
                      return (
                        <tr
                          key={index + "_" + item.category}
                          className={`${props.selectedRebateCategory !==
                              `${d.vendor}_${item.category}` &&
                              props.selectedVendor !== "" &&
                              selectedVendor !== ""
                              ? "low-opacity clickable"
                              : "clickable"
                            }`}
                          onClick={() => {
                            props.updateRebateCategory(
                              `${d.vendor}_${item.category}`
                            );
                            props.updateRebateData(item.rebatedata);
                            props.updateSummaryData(item.summary);
                            props.updateChartData(item.charts);
                            props.updateVendor(d.vendor);
                          }}
                        >
                          <td
                            onClick={(e: any) => {
                              e.stopPropagation();
                            }}
                            className="not-clickable"
                          ></td>
                          <td>{item.category}</td>
                          <td>
                            {numberFormatter(
                              item.tableData.forecatedSpendBasedonYTDGrowth,
                              0,
                              "$"
                            )}
                          </td>
                          <td>
                            {numberFormatter(
                              item.tableData
                                .forecatedMonthlySpendBasedonYTDGrowth,
                              0,
                              "$"
                            )}
                          </td>
                          <td>
                            {numberFormatter(
                              item.tableData.forecastedNIAbasedonYTDgrowth,
                              0,
                              "$"
                            )}
                          </td>
                          <td>
                            {numberFormatter(
                              item.tableData.additionalMonthlySpendRequired,
                              0,
                              "$"
                            )}
                          </td>
                          <td>
                            {numberFormatter(
                              item.tableData.additinalNIAopp,
                              0,
                              "$"
                            )}
                          </td>
                        </tr>
                      );
                    }
                  })
                  : ""}
              </>
            );
          })}
        </tbody>
      </table>
      <div className="pagination-component">
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["total", "-", "pager", "skip"]}
          total={props.count}
          limit={limit}
          activePage={props.pageNumber}
          onChangePage={(e) => {
            props.updatePageNumber(e);
          }}
          className=""
        />
      </div>
    </>
  );
};
export default NextTierTable;
